function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#c8d2d6",
  d: "M58.87 78.97H81.5v10.37H58.87z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74 89.34H58.87V79h8.88a6.2 6.2 0 016.2 6.2z",
  fill: "#e7eced"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 67.82,
  cy: 84.16,
  r: 2.36,
  fill: "#7383bf"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.32 44.75A3.3 3.3 0 1062 40.41z",
  fill: "#fad4c6"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71 49.46a3.3 3.3 0 10-4.34-4.34z",
  fill: "#fad4c6"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.75 54.18a3.3 3.3 0 10-4.35-4.35z",
  fill: "#fad4c6"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.46 58.89a3.3 3.3 0 10-4.34-4.34zm-19.24 6.88H51.8a3.3 3.3 0 01-3.3-3.3 3.31 3.31 0 013.3-3.3h9.42a3.31 3.31 0 013.3 3.3 3.3 3.3 0 01-3.3 3.3z",
  fill: "#fad4c6"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.68 64.42L70.2 74.9a2.15 2.15 0 01-3.06 0L58 65.77h-6.2c-.55.27-2-.69-1.47-.21l10.2 10.16c.07.07.15.12.22.18V79h18.86v-4.28a7 7 0 001.07-10.3z",
  fill: "#d3b1a7"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59 37.38L44.29 52.05l7.15 7.16h9.78a3.3 3.3 0 010 6.6H58l6 6L78.67 57.1z",
  fill: "#424a60"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M59 37.38l-2.09-2.09a2.17 2.17 0 00-3.06 0L42.2 46.9a2.15 2.15 0 000 3.06l2.09 2.09zm22.8 22.85l-3.13-3.13L64 71.76l3.14 3.14a2.16 2.16 0 003 0L81.8 63.29a2.15 2.15 0 000-3.06z",
  fill: "#e7eced"
});

var _ref14 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 73.48,
  cy: 66.24,
  r: 1.89,
  fill: "#fff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.44 45a.95.95 0 01-.67-1.61l1.89-1.89A.94.94 0 0152 42.87l-1.9 1.88a.9.9 0 01-.66.25z",
  fill: "#424a60"
});

var SvgIcController = function SvgIcController(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcController as ReactComponent };